function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * done
 */
import { createEffectHook } from '@formily/core';
import { RecursionField, useField, useForm } from '@formily/react';
import React, { useEffect, useState } from 'react';
import { useApiFormDetail } from "../../services";
export var onIncludeLoadStart = createEffectHook('onIncludeLoadStart', function (payload, form) {
  return function (listener) {
    return listener(payload, form);
  };
});
export var onIncludeLoadEnd = createEffectHook('onIncludeLoadEnd', function (payload, form) {
  return function (listener) {
    return listener(payload, form);
  };
});
export var onIncludeLoadRetry = createEffectHook('onIncludeLoadRetry', function (payload, form) {
  return function (listener) {
    return listener(payload, form);
  };
});
export var onIncludeLoadFailed = createEffectHook('onIncludeLoadFailed', function (payload, form) {
  return function (listener) {
    return listener(payload, form);
  };
});
export var onIncludeLoadSuccess = createEffectHook('onIncludeLoadSuccess', function (payload, form) {
  return function (listener) {
    return listener(payload, form);
  };
});
export var Include = function Include(props) {
  var formCode = props.formCode,
    formVersion = props.formVersion,
    _props$retry = props.retry,
    retry = _props$retry === void 0 ? 5 : _props$retry,
    _props$allowLoadingFa = props.allowLoadingFail,
    allowLoadingFail = _props$allowLoadingFa === void 0 ? false : _props$allowLoadingFa,
    loading = props.loading;
  var form = useForm();
  var field = useField();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    schema = _useState2[0],
    setSchema = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    fail = _useState4[0],
    setFail = _useState4[1];
  var apiFormDetail = useApiFormDetail();
  useEffect(function () {
    if (!formCode) {
      console.error('include component missing formCode');
      return;
    }

    // if (loading) {
    //   Taro.showLoading({ title: '' })
    // }

    form.notify('onIncludeLoadStart', {
      path: field.path,
      formCode: formCode,
      formVersion: formVersion
    });
    var loadForm = function loadForm() {
      var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return apiFormDetail({
        formCode: formCode,
        formVersion: formVersion
      }).then(function (result) {
        if (result.code === 0) {
          try {
            var formSchema = JSON.parse(result.data.formSchema);
            setSchema(formSchema);
            form.notify('onIncludeLoadSuccess', _objectSpread({
              path: field.path
            }, result.data));
          } catch (e) {
            throw new Error('表单格式错误');
          }
        } else {
          throw result;
        }
      }).catch(function (error) {
        // console.error('include error', count, error)
        if (count < retry) {
          form.notify('onIncludeLoadRetry', {
            retry: count,
            path: field.path,
            formCode: formCode,
            formVersion: formVersion
          });
          return loadForm(count + 1);
        } else {
          if (!allowLoadingFail) {
            var msg;
            if (error instanceof Error) {
              msg = error.message;
            } else {
              msg = error.msg || '加载失败';
            }
            form.notify('onIncludeLoadFailed', {
              path: field.path,
              formCode: formCode,
              formVersion: formVersion,
              error: error
            });
            var fieldName = "error";
            setFail({
              type: 'object',
              properties: _defineProperty({}, fieldName, {
                type: 'string',
                'x-decorator': 'FormItem',
                'x-decorator-props': {
                  hiddenLabel: true,
                  forceShowError: true,
                  reaction: {
                    depends: [fieldName],
                    state: {
                      selfErrors: [msg]
                    }
                  }
                }
              })
            });
          }
        }
      });
    };
    loadForm().finally(function () {
      // if (loading) {
      //   Taro.hideLoading()
      // }
      form.notify('onIncludeLoadEnd', {
        path: field.path,
        formCode: formCode,
        formVersion: formVersion
      });
    });
  }, [formCode, formVersion]);
  console.log('render include', fail, schema, field);
  if (fail) {
    return /*#__PURE__*/React.createElement(RecursionField, {
      schema: fail
    });
  }
  if (!schema) {
    return null;
  }
  return /*#__PURE__*/React.createElement(RecursionField, {
    schema: schema
  });
};